import { toAllFatoFeatures } from '@components/map/layers/vertiports/vertiport.mapper';
import { flightAdapter, vertiportAdapter } from '@redux/intercom/intercom.adapters';
import { IntercomState } from '@redux/intercom/intercom.reducer';
import { RootState } from '@redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectParameter } from '@utils/common.utils';
import { FeatureCollection } from 'geojson';

import { Flight } from '@/types/intercom/intercom.types';

function selectIntercom(state: RootState): IntercomState {
  return state.intercom;
}

const { selectAll: selectAllVertiports, selectById: selectVertiportByCode } = vertiportAdapter.getSelectors(
  (state: RootState) => selectIntercom(state).vertiports,
);

export const VertiportSelectors = {
  selectAllVertiports,
  selectVertiportByCode,
};

export const selectVertiportFeatures = createSelector(
  [selectAllVertiports],
  (vertiports): FeatureCollection => ({
    type: 'FeatureCollection',
    features: [...toAllFatoFeatures(vertiports)],
  }),
);

const { selectAll: selectAllFlights, selectById: selectFlightById } = flightAdapter.getSelectors(
  (state: RootState) => selectIntercom(state).flights,
);

export const FlightSelectors = {
  selectAllFlights,
  selectFlightById,
};

export const selectFlightByDisplayId = createSelector(
  [selectAllFlights, selectParameter<string | null>],
  (flights: Flight[], displayId: string | null): Flight | null =>
    flights.find((flight) => flight.aircraftId === displayId) ?? null,
);
